<template>
  <div>
    <v-toolbar absolute flat app theme--dark primary elevation-6>
      <logo />

      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn depressed :to="{ name: 'benefits_all' }">Dostępne usługi</v-btn>

        <v-btn depressed :to="{ name: 'history' }">Historia</v-btn>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon flat @click.prevent="logout" v-on="on">
              <v-icon>mdi-exit-to-app</v-icon>
            </v-btn>
          </template>

          <span>Wyloguj się</span>
        </v-tooltip>
      </v-toolbar-items>
    </v-toolbar>

    <header-image />
  </div>
</template>

<script>
import { mapState } from 'vuex';

import store from '@/store/store';
import Logo from '@/components/Logo.vue';
import HeaderImage from '@/components/layout/HeaderImage';
import { SessionStorage } from '@/enums/sessionStorage.enum';
import { config } from '@/utils/config';

// @vuese
// Header strony z nagłówkiem i ikonami do niektórych widoków
// @group MainLayout
export default {
  components: { Logo, HeaderImage },
  methods: {
    // @vuese
    // Metoda do wylogowywania użytkownika
    // Czyści session storage
    async logout() {
      await this.$store.dispatch('auth/logout');
      this.$router.push({ name: 'login' });
    }
  }
};
</script>

<style>
.city-card {
  padding-left: 1rem;
  font-size: 1.7rem;
  color: teal;
  font-weight: 300;
}
</style>